import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorService } from './services/interceptor.service';
import { SpinnerOverlayComponent } from './features/spinner-overlay/spinner-overlay.component';



@NgModule({ declarations: [SpinnerOverlayComponent], imports: [CommonModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }
